import * as api from '../../services/tax/apiTaxGroup';
import * as apiCommon from '../../services/apiCommon';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListTaxGroupSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_TAX_GROUP', callFetchListTaxGroup, feathersApp);
}

function* callFetchListTaxGroup(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'tax_group'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveTaxGroupSaga(feathersApp) {
	yield takeEvery("SAVE_TAX_GROUP", callSaveTaxGroup, feathersApp);
}
function* callSaveTaxGroup(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveTaxGroup, feathersApp, params);

		yield common.doneSaveRecord(result, 'Tax group was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListTaxGroup(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteTaxGroupFromListSaga(feathersApp) {
	yield takeEvery('DELETE_TAX_GROUP_FROM_LIST', callDeleteTaxGroupFromList, feathersApp);
}

function* callDeleteTaxGroupFromList(feathersApp, action) {
	yield deleteTaxGroup(feathersApp, action);
	yield delay(2000);
	yield callFetchListTaxGroup(feathersApp, { silent: true });
}

function* deleteTaxGroup(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteTaxGroup, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.TAX_GROUP } });
			yield callFetchListTaxGroup(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteTaxGroupSaga(feathersApp) {
	yield takeEvery('DELETE_TAX_GROUP', callDeleteTaxGroup, feathersApp);
}

function* callDeleteTaxGroup(feathersApp, action) {
	yield deleteTaxGroup(feathersApp, action);
	yield delay(2000);
	yield callFetchListTaxGroup(feathersApp, { silent: true });
}

export function* fetchTaxGroupForEditSaga(feathersApp) {
	yield takeEvery('FETCH_TAX_GROUP_BY_ID', callFetchTaxGroupForEdit, feathersApp);
}

function* callFetchTaxGroupForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.TAX_GROUP;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchTaxGroupById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
